import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledButtonBlack
} from "../../../styles/MyStyles";

const CountryEditPage = () => {
    const { countryId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [country, setCountry] = useState({
        name: '',
        alpha2: '',
        id: 0
    });

    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (countryId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_COUNTRIES_URL}/${countryId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        const fetchedEntities = data.data;
                        setCountry(fetchedEntities);
                    } else {
                        console.log('Fetch country failed.');
                    }
                } else {
                    setCountry({
                        name: '',
                        alpha2: '',
                        id: 0
                    });
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchCountry();
    }, [countryId]);

    const validateForm = () => {
        let newErrors = {};

        if (!country.name.trim()) {
            newErrors.name = 'Name is required.';
        }

        if (!country.alpha2.trim()) {
            newErrors.alpha2 = 'Alpha-2 is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setCountry({
            ...country,
            [event.target.name]: event.target.value,
        });

        setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_COUNTRIES_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(country),
                }
            );
            if (response.ok) {
                console.log('Country updated successfully.');
                handleGoBack();
            } else {
                console.log('Update country failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleDelete = async () => {
        try {
            console.log(country);
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_COUNTRIES_URL}/${country.id}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                console.log('Country deleted successfully.');
                handleGoBack();
            } else {
                console.log('Delete country failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {countryId ? 'Edit Country' : 'Create Country'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
                {(countryId && <StyledButtonBlack variant="contained" onClick={handleDelete}>
                    Delete
                </StyledButtonBlack>)}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Name</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="name"
                                label="Name"
                                value={country.name}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.name}
                                helperText={errors.name}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Alpha 2</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="alpha2"
                                label="Alpha-2"
                                value={country.alpha2}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.alpha2}
                                helperText={errors.alpha2}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default CountryEditPage;
